import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Urls } from "../Urls";
import { map } from "rxjs/operators";
import { Observable, forkJoin, of as observableOf } from "rxjs";
import { MsalService } from "@azure/msal-angular";
import { AccountInfo } from '@azure/msal-browser';
import { OperatorHelpers } from "../helpers/operator.helpers";
import { IUserProfile } from "../models/interfaces/user-profile";
import { IUser, IUserRole } from "../models/interfaces/user";

@Injectable({
  providedIn: "root",
})
export class UserService {
  account: AccountInfo | null = null;
  constructor(private http: HttpClient, private authService: MsalService) {}

  signout() {
    //this.authService.logoutPopup();
  }

  checkIfLoggedInUserAdminByEmailId(email: string): Observable<boolean> {
    return this.http.get(Urls.checkIfLoggedInUserIsAdmin(email)).pipe(
      map(responseData => {
        return responseData as boolean;
      })
    );
  }

  removeUser(email: string): Observable<string> {
    return this.http
      .delete(Urls.deleteUserByEmailAndAccessLevel(email), {
        responseType: "text" as "json",
      })
      .pipe(
        map((responseData) => {
          return responseData as string;
        })
      );
  }

   getAllSfrsPersonnel(): Observable<IUserProfile[]> {
     return this.http.get(Urls.getAllSrfsUsers).pipe(
       map((responseData) => {
         const result: IUserProfile[] = [];
         if (!responseData) {
           return result;
         }

         return OperatorHelpers.mapToList(responseData, result);
       })
     );
   }

  getAllAdUsers(): Observable<IUserProfile[]> {
    return this.http.get(Urls.getAllAdUsers).pipe(
      map((responseData) => {
        const result: IUserProfile[] = [];
        if (!responseData) {
          return result;
        }

        return OperatorHelpers.mapToList(responseData, result);
      })
    );
  }

  getActiveUsers(): Observable<IUser[]> {
      return this.http.get(Urls.getAllUsers).pipe(
        map((responseData) => {
          const result: IUser[] = [];
          if (!responseData) {
         return result;
       }

       return OperatorHelpers.mapToList(responseData, result);
     })
   );
 }

getActiveUserByEmailId(email: string): Observable<IUser | null> {
  return this.http.get(Urls.getActiveUserByEmailId(email)).pipe(
    map((responseData) => {
      if (!responseData) {
        return null;
      }

      return responseData as IUser;
    })
  );
}

getUserById(id: number): Observable<IUser | null> {
  return this.http.get(Urls.getUserById(`${id}`)).pipe(
    map((responseData) => {
      if (!responseData) {
        return null;
      }

      return responseData as IUser;
    })
  );
}

getAllPartners(): Observable<IUser[]> {
  return this.http.get(Urls.getAllPartnerUsers).pipe(
    map((responseData) => {
      const result: IUser[] = [];
      if (!responseData) {
        return result;
      }

      return OperatorHelpers.mapToList(responseData, result);
    })
  );
}

isSfrsOrAdminUser(): Observable<boolean> {
    const email = this.getCurrentUser();
    if (email) {
      return this.http.get(Urls.getIsSrfsOrAdminUser(email)).pipe(
        map((responseData) => {
          return responseData as boolean;
        })
      );
    }

    return observableOf<boolean>(false);
  }

  updateUser(user: IUser): Observable<IUser> {
     return this.http.put(Urls.updateUser, user).pipe(
       map((responseData) => {
         return responseData as IUser;
       })
     );
  }

  updateUserRole(userRole: IUserRole): Observable<any> {
     return this.http.put(Urls.updateUserRole, userRole).pipe(
       map((responseData) => {
         return responseData;
       })
     );
  }

  registerUserSignIn(email: string): Observable<any> {
     return this.http.get(Urls.registerUserSignIn(email)).pipe(
       map((responseData) => {
         return responseData;
       })
    );
   }

   getClaims(email: string): Observable<any> {
    const claims = this.http.get(Urls.getClaims(email));
    const dbUser = this.http.get(Urls.getUserByEmailId(email));
    return forkJoin([claims, dbUser]);
  }

  getCurrentUser() {
    if (this.account) {
      const currentUser = this.account?.username;
      if(currentUser){
        return currentUser;
      }
    }
    //console.log("getCurrentUser no acc");
    return null;
  }

  getUserFullName() {
    if (this.account) {
      const currentAcc = this.account?.name;
      if(currentAcc){
        return currentAcc;
      }
    }

    return null;
  }

  getUserInitials() {
    if (this.account) {
      const currentAcc = this.account?.name;

      if(currentAcc){
        const names = currentAcc.replace(" ", "").split(",");
        if (names.length > 1) {
          return names[1][0].toUpperCase() + names[0][0].toUpperCase();
        } else {
          return names[0].substring(0, 2).toUpperCase();
        }

      }
    }

    return null;
  }
}
